<template>
  <div v-if="isShow" class="orientation-alert">
    <p><img src="@/assets/images/sumaho_yokomuki.png" alt=""></p>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'OrientationAlert',
  components: {
  },
  props: {
  },
  setup(props, context) {
    const isShow = ref(false);

    const handleChangeOrientation = () => {
      if (window.orientation === 0) {
        isShow.value = false;
      } else {
        isShow.value = true;
      }
    }

    onMounted(() => {
      handleChangeOrientation();
    });

    window.addEventListener("orientationchange", handleChangeOrientation);

    return {
      isShow
    }
  },
}
</script>

<style scoped lang="scss">
.orientation-alert {
  position: fixed;
  z-index: 500;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: url(~@/assets/images/top/bg_top.png);
  background-size: cover;
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    img {
      width: 70vh;
      width: 70svh;
    }
  }
}
.stage1 {
  background-image: url(~@/assets/images/stage1/bg.png);
}
.stage2 {
  background-image: url(~@/assets/images/stage2/bg.png);
}
.stage3 {
  background-image: url(~@/assets/images/stage3/bg.png);
}
.stage4 {
  background-image: url(~@/assets/images/stage4/bg.png);
}
</style>